<template>
  <div class="dots">
    <div v-for="item in 5" :key="item" class="d-inline-block">
      <div v-if="item < number || item == number" class="dot active"></div>
      <div v-else class="dot"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    number: {
      type: String,
      required: true
    }
  }
}
</script>
